export default function populatePayoutCheckingForm(formData, data = {}) {
  const result = {
    ...formData,
  };

  const details = data.details;

  if (details.type) {
    result.type = details.type;
  }

  if (details.accountType) {
    result.accountType = details.accountType;
  }

  if (details.lastFour) {
    result.accountNumber = details.lastFour;
  }

  if (details.institutionNumber) {
    result.institutionNumber = details.institutionNumber;
  }

  if (details.branchNumber) {
    result.branchNumber = details.branchNumber;
  }

  if (details.firstName) {
    result.firstName = details.firstName;
  }

  if (details.lastName) {
    result.lastName = details.lastName;
  }

  result.valid = false;

  result.paymentOption = data;

  result.onChangeValidate = {
    lastName: true,
    firstName: true,
    branchNumber: true,
    institutionNumber: true,
    accountNumber: true,
    accountType: true,
  };

  return result;
}
